<template>
    <b-form @submit.prevent="onSearch()">
        <b-form-group :label="$t('kkm.kkmSfdNum')">
            <b-form-input v-model="kkmId" required/>
        </b-form-group>
        <b-form-row class="mx-0">
            <b-button type="submit" variant="success" class="ml-auto" :disabled="isDisabled">
                <magnify-icon title="" />&nbsp;{{ $t('general.search') }}
            </b-button>
        </b-form-row>
    </b-form>
</template>

<script>
/* eslint-disable */
import AppData from '@/utils/appdata'

export default {
    name: 'SearchAttributeForm',
    mixins: [AppData],
    data() {
        return {
            kkmId: null
        } 
    },
    methods: {
        onSearch() {
            this.$emit('onSearch', this.kkmId);
        } 
    }
}
</script>